<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>

<div class="container">
    <div class="row">
        <h6 class="ms-2 mt-3 mb-2">
            <button class="btn btn-sm back-button" routerLink="/auth/login">
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                            d="M10 4.44493H1.91406L5.20508 7.37059L4.50195 8L0 4.00217L4.50195 0L5.20508 0.629409L1.91406 3.55507H10V4.44493Z"
                            fill="#686988"/>
                </svg>
                Back
            </button>
        </h6>
    </div>

    <div class="bg-white mt-3 d-flex justify-content-between p-3">
        <div>
            <h6>AUDIT TRAIL</h6>
        </div>

        <div class="d-flex justify-content-end">
            <button class="custom-search-button" (click)="toggleSearch()">
                Search
                <span class="mdi mdi-magnify custom-search-icon"></span>
            </button>
        </div>
    </div>
    <div class="search-parameters" *ngIf="showSearch">
        <form class="search-form" [formGroup]="assessmentSearchForm">
            <button class="btn btn-outline-secondary btn-sm position-absolute top-0 end-0" (click)="toggleSearch()">
                <span class="mdi mdi-close"></span>
            </button>
            <div class="row mt-2 mb-3">

                <div class="col-md-3">
                    <label>Assessment ID</label>
                    <input type="text" class="form-control small-option-font" formControlName="assessmentId" />

                </div>

                <div class="col-md-3">
                    <label>ASIN</label>
                    <input type="text" class="form-control small-option-font" formControlName="asin" />

                </div>

                <div class="col-md-3">
                    <label>Approval Status</label>
                    <select class="form-control small-option-font" formControlName="approvalStatus">
                        <option value="">-- Select--</option>
                        <option value="APPROVED">Approved</option>
                        <option value="PENDING">Pending</option>
                        <option value="QUERIED">Queried</option>
                    </select>
                </div>

                <div class="col-md-3">
                    <label>Payment Status</label>
                    <select class="form-control small-option-font" formControlName="paymentStatus">
                        <option value="">-- Select--</option>
                        <option value="PAID">Paid</option>
                        <option value="NOT_PAID">Not Paid</option>
                    </select>
                </div>

                <div class="col-md-3">
                    <label>Start Date</label>
                    <input type="date" class="form-control small-option-font" formControlName="from" />
                </div>
                <div class="col-md-3">
                    <label>End Date</label>
                    <input type="date" class="form-control small-option-font" formControlName="to" />
                </div>

                <div class="col-md-3 col-sm-9">
                    <button [disabled]="!assessmentSearchForm.valid" class="btn btn-sm search-button"
                            (click)="search(); toggleSearch()" type="submit">
                        Search
                    </button>
                </div>

            </div>

        </form>

    </div>
    <!-- <div class="table-responsive"> -->
    <table class="table table-striped table-hover table-bordered">
        <thead class="table-dark">
        <tr>
            <th scope="col" class="assess-table-head">S/N</th>
            <th scope="col" class="assess-table-head">Action</th>
            <th scope="col" class="assess-table-head">Time</th>
            <th scope="col" class="assess-table-head">Browser</th>
            <th scope="col" class="assess-table-head">Device Used</th>
            <th scope="col" class="assess-table-head">Operation System Used</th>
<!--            <th scope="col" class="assess-table-head">URL Assessed</th>-->
            <th scope="col" class="assess-table-head">Action Description</th>
        </tr>
        </thead>
        <tbody *ngIf="!isSearching && data?.length > 0;">
        <tr *ngFor="let d of data; let i = index;">
            <td>
                <span class="badge bg-dark">{{ i + num + 1 }}</span>
            </td>
            <td>
                {{ d?.action }}
            </td>
            <td>
                {{ d?.createdAt | date: 'medium' }}
            </td>
            <td>
                {{ d?.browser}}
            </td>
            <td>
                {{ d?.device }}
            </td>
            <td>
                {{ d?.os }}
            </td>
<!--            <td>-->
<!--                {{ d?.route }}-->
<!--            </td>-->
            <td>
                {{ d?.description }}
            </td>
        </tr>
        </tbody>
    </table>

    <div class="pagination justify-content-end">
        <ngb-pagination *ngIf="!isSearching && data?.length > 0"
                        class="d-flex justify-content-center my-3"
                        [(page)]="currentPage" (pageChange)="performSearch($event)" [maxSize]="5"
                        [pageSize]="pageSize"
                        [collectionSize]="count" [boundaryLinks]="true" [directionLinks]="true"
                        [rotate]="true">
        </ngb-pagination>

    </div>
    <!-- </div> -->
</div>
<div style="position: sticky !important;bottom: 0 !important;">
    <app-footer *ngIf="hasAccess(['ADMIN'])" class="m-hidden"></app-footer>
    <app-mda-footer *ngIf="hasAccess(['MDA'])" class="m-hidden"></app-mda-footer>

</div>